import { tv } from '@workspace/lib';

export const footerVariants = tv({
  slots: {
    footer: 'bg-accent',
    container: 'px-md py-2xl md:px-4xl md:pt-4xl md:pb-md-banner',
    contentGrid: 'gap-y-3xl md:gap-y-0',
    columnTitle: 'text-black font-semibold font-heading',
    columnLink: 'text-black !text-base !font-extralight hover:underline !no-underline',
    columnLinkBold: 'text-black !text-base !font-bold font-heading hover:underline !no-underline',
    contactHeading: 'text-black !font-semibold !text-base font-heading',
    contactDetail: 'text-black !font-normal !text-xs font-body',
    contactIcon: 'text-black',
    footerBottom: 'bg-primary',
    footerBottomContainer: 'px-md py-lg md:px-4xl',
    footerBottomContent: 'gap-xl text-sm',
    footerBottomText: 'text-white',
  },
});
